import React from 'react';
import BluetoothAudioPanel from '../AreaOverview/BluetoothAudioPanel';
import useDeviceTelemetry from './useDeviceTelemetry';

function AudioRoutingTab({ device, area, topology, onTopologyChange }) {
  const telemetry = useDeviceTelemetry(device);

  return (
    <BluetoothAudioPanel
      device={device}
      snapshot={telemetry.bluetoothAudio}
      status={telemetry.status}
      onRefresh={telemetry.refresh}
      settingsStatus={telemetry.settingsStatus}
      settingsMessage={telemetry.settingsMessage}
      onOpenSettings={telemetry.openBluetoothSettings}
      areaId={area?.id}
      topology={topology}
      onTopologyChange={onTopologyChange}
    />
  );
}

export default AudioRoutingTab;
